import {Component, Input, OnInit} from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-avatar-filler',
    templateUrl: './avatar-filler.component.html',
    styleUrls: ['./avatar-filler.component.scss'],
    standalone: true,
    imports: [NgClass]
})
export class AvatarFillerComponent implements OnInit {

  @Input() user;
  @Input() size: 'lg' | 'md' | 'sm' | 'fill' = 'lg';

  private letters = '0123456789ABCDEF';
  public color: string = 'transparent';
  public displayedLetters: string = '';
  public textColor:string = 'transparent';
  public avatarUrl:string = '';

  constructor() { }

  ngOnInit(): void {
    if (this.user.avatar !== 'default-avatar.png') {
      this.avatarUrl = this.user.avatar;
    } else {
      this.getRandomColor();
      this.getLetters();
    }
  }

  // génère une couleur aléatoire et set la couleur de l'écriture
  private getRandomColor() {
    this.color = '#'; // <-----------
    for (let i = 0; i < 6; i++) {
      this.color += this.letters[Math.floor(Math.random() * 16)];
    }
    this.textColor = this.pickTextColorBasedOnBgColorSimple(this.color, 'text-white', 'text-black');
  }

  // Récupère la première lettre du nom & du prénom
  private getLetters() {
    const nameSplitted = this.user.name.split(' ');
    if (nameSplitted && nameSplitted.length > 0) {
      nameSplitted.forEach(n => {
        this.displayedLetters += n.substring(0, 1);
      })
    }
  }

  // Check la couleur du bg et indique si l'écriture doit être clair ou foncée pour ressortir
  private pickTextColorBasedOnBgColorSimple(bgColor, lightColor, darkColor) {
    let color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
    let r = parseInt(color.substring(0, 2), 16);
    let g = parseInt(color.substring(2, 4), 16);
    let b = parseInt(color.substring(4, 6), 16);
    return (((r * 0.299) + (g * 0.587) + (b * 0.114)) > 186) ?
      darkColor : lightColor;
  }

}
